module.exports = __webpack_public_path__ + "img/6.24071c81.png";